import Button from 'components/inputs/button'
import { FC } from 'react'

interface Props {
  heading?: string
  message: string
  buttonText?: string
  buttonAction?: () => void
}

const EmptyView: FC<Props> = ({
  heading,
  message,
  buttonText,
  buttonAction,
}) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 py-20 tracking-normal">
      <div className="flex flex-col items-center justify-center gap-1">
        <p className="text-xl font-bold text-gray-500">
          {heading || 'Nothing Here'}
        </p>
        <p className="text-sm font-semibold text-gray-400">{message}</p>
      </div>
      {buttonText && (
        <Button
          className="rounded-md border-none bg-gray-100 px-4 py-1 text-sm font-semibold tracking-normal text-gray-500 hover:bg-gray-200"
          disabled={!buttonAction}
          onClick={buttonAction}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}

export default EmptyView
